import * as actionTypes from "./withdrawalActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
import { toast } from 'react-toastify';
import { getAffiliateProfile } from '../affiliate/affiliateAction';
const { REACT_APP_API_URL } = process.env;

export const createWithdrawal = (data, onSuccess) => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('affiliateToken')}` } };
    return (dispatch) => {
        dispatch({ type: actionTypes.CREATE_WITHDRAWAL });
        apiTimeout(axios.post(`${REACT_APP_API_URL}/withdrawal/request`, data, config))
        .then((response) => {
            toast.success("Withdrawal request submitted successfully.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
            dispatch({ type: actionTypes.CREATE_WITHDRAWAL_SUCCESS, payload: response.data.data });
            dispatch(getAffiliateProfile()); // Refresh profile/wallet balance
            dispatch(getWithdrawals()); // Refresh withdrawal list
            if (onSuccess) onSuccess();
        })
        .catch(function (error) {
            dispatch({ type: actionTypes.CREATE_WITHDRAWAL_FAILURE });
            checkError(error);
        });
    };
};

export const getWithdrawals = () => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('affiliateToken')}` } };
    return (dispatch) => {
        dispatch({ type: actionTypes.GET_WITHDRAWALS });
        apiTimeout(axios.get(`${REACT_APP_API_URL}/withdrawal/current`, config))
        .then((response) => {
            dispatch({ type: actionTypes.GET_WITHDRAWALS_SUCCESS, payload: response.data.data });
        })
        .catch(function (error) {
            dispatch({ type: actionTypes.GET_WITHDRAWALS_FAILURE });
            checkError(error);
        });
    };
};
